import { type FC, useMemo } from 'react'

export const ApplicantInfoEntry: FC<{
  label: string
  icon: React.ReactNode
  value?: string | React.ReactNode
}> = ({ label, icon, value }) => {
  const val = useMemo(() => {
    if (typeof value === 'string') {
      const trimmed = value?.trim() ?? ''

      if (!trimmed) {
        return '-'
      }
      return trimmed
    }
    return value
  }, [value])

  return (
    <div className="flex items-start gap-2 py-[5px]">
      <div className="flex items-start gap-2 text-sm leading-[24px] text-muted-foreground">
        <div className="mt-1">{icon}</div>
        {label}
      </div>
      <div className="leading-[24px]">{val}</div>
    </div>
  )
}
